import Label from '@superfunnel/ui-core/v2/Label';
import Switch from '@superfunnel/ui-core/v2/Switch';
import { classNames } from '@superfunnel/utils';
import SettingsHelpTooltip from './SettingsHelpTooltip';

interface Props {
  title?: string;
  value?: boolean;
  setValue?: (checked: boolean) => void;
  helpText?: string;
  className?: string;
}

export default function SettingsToggle({
  title,
  value,
  setValue,
  helpText,
  className,
}: Props) {
  return (
    <div
      className={classNames(
        'font-inter grid w-full items-center gap-1',
        className,
      )}
    >
      <Label
        htmlFor="email"
        className="text-base-700 flex items-center gap-2 text-sm font-medium"
      >
        {title}{' '}
        {helpText && <SettingsHelpTooltip text={helpText} iconSize="sm" />}
      </Label>
      <div className="grid grid-cols-1 gap-2">
        <Switch key={'edit-name'} checked={value} onCheckedChange={setValue} />
      </div>
    </div>
  );
}
